var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "600" },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          $event.preventDefault()
          return _vm.onenter.apply(null, arguments)
        },
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "290" },
          model: {
            value: _vm.dialog_edit,
            callback: function ($$v) {
              _vm.dialog_edit = $$v
            },
            expression: "dialog_edit",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "text-h5" }, [
                _vm._v("Edit level: " + _vm._s(_vm.dialog_edit_index)),
              ]),
              _c("v-card-text", [
                _vm._v("Select used colors and type of cauldron."),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-card",
        [
          _c("v-card-title", [
            _c("span", { staticClass: "headline" }, [
              _vm._v(
                "Novice Battle Pass Bundle (" + _vm._s(this.rules.name) + ")"
              ),
            ]),
          ]),
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                { staticClass: "mb-4 pt-4", attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "12", sm: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          disabled: "",
                          label: "UID:",
                          "hide-details": "",
                          outlined: "",
                          dense: "",
                        },
                        model: {
                          value: _vm.model.uid,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.model,
                              "uid",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "model.uid",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("v-text-field", {
                    directives: [
                      { name: "ascii-only", rawName: "v-ascii-only" },
                    ],
                    staticClass: "mr-2",
                    attrs: { label: "Name" },
                    model: {
                      value: _vm.model.name,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.model,
                          "name",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "model.name",
                    },
                  }),
                  _c("v-text-field", {
                    directives: [
                      { name: "ascii-only", rawName: "v-ascii-only" },
                    ],
                    attrs: { label: "Key" },
                    model: {
                      value: _vm.model.key,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.model,
                          "key",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "model.key",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mt-3", attrs: { dense: "" } },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "ma-0 pa-2 mt-2 pb-0",
                      attrs: { width: "100%", elevation: "0", outlined: "" },
                    },
                    [
                      _c(
                        "v-card-actions",
                        {
                          staticClass: "ma-0 pa-1",
                          attrs: { width: "100%", elevation: "0" },
                        },
                        [
                          _c(
                            "v-card-title",
                            { staticClass: "blue--text pa-0 ma-0 ml-1" },
                            [_vm._v("Days")]
                          ),
                          _c("v-spacer"),
                          _c(
                            "v-btn",
                            {
                              staticClass: "green--text",
                              attrs: {
                                icon: "",
                                elevation: "0",
                                color: "white",
                                dense: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.add_day()
                                },
                              },
                            },
                            [_c("v-icon", [_vm._v("mdi-plus")])],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-card",
                        {
                          staticClass: "ma-0",
                          attrs: {
                            width: "100%",
                            elevation: "0",
                            outlined: "",
                          },
                        },
                        [
                          _c(
                            "v-list",
                            { staticClass: "ma-0 pa-0" },
                            _vm._l(_vm.model.days, function (day) {
                              return _c(
                                "v-list-group",
                                {
                                  key: day.uid,
                                  attrs: {
                                    value: _vm.expandedDayUID === day.uid,
                                    "no-action": "",
                                  },
                                  on: {
                                    input: function ($event) {
                                      return _vm.toggleExpand(day.uid)
                                    },
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function () {
                                          return [
                                            _c(
                                              "v-card",
                                              {
                                                staticClass:
                                                  "d-flex pa-1 pl-3 ma-1",
                                                class:
                                                  _vm.expandedDayUID === day.uid
                                                    ? "white--text"
                                                    : "black--text",
                                                attrs: {
                                                  elevation: "0",
                                                  outlined: "",
                                                  width: "100%",
                                                  color:
                                                    _vm.expandedDayUID ===
                                                    day.uid
                                                      ? "blue"
                                                      : undefined,
                                                },
                                              },
                                              [
                                                _c("v-list-item-title", [
                                                  _vm._v(
                                                    _vm._s(day.name) +
                                                      ", quests: " +
                                                      _vm._s(
                                                        day.quests.length
                                                      ) +
                                                      ", latency: " +
                                                      _vm._s(day.latency)
                                                  ),
                                                ]),
                                                _c(
                                                  "v-card",
                                                  {
                                                    staticClass:
                                                      "pa-1 d-flex align-center",
                                                    attrs: { elevation: "0" },
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        staticClass: "mr-2",
                                                        attrs: {
                                                          small: "",
                                                          color: "grey",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.edit_day(
                                                              day.uid
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_vm._v("mdi-pencil")]
                                                    ),
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        staticClass: "mr-2",
                                                        attrs: {
                                                          small: "",
                                                          color: "red",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.remove_day(
                                                              day.uid
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_vm._v("mdi-delete")]
                                                    ),
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          small: "",
                                                          color: "green",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.add_quest(
                                                              day.uid
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_vm._v("mdi-plus")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _c(
                                    "v-list-item",
                                    [
                                      _c(
                                        "v-card",
                                        {
                                          attrs: {
                                            outlined: "",
                                            height: "100%",
                                            width: "100%",
                                          },
                                        },
                                        [
                                          _c("v-data-table", {
                                            staticStyle: {
                                              "white-space": "nowrap",
                                              width: "100%",
                                            },
                                            attrs: {
                                              headers: _vm.header_quests,
                                              items: day.quests,
                                              "item-key": "uid",
                                              "disable-pagination": "",
                                              "hide-default-footer": "",
                                              dense: "",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "item.actions",
                                                  fn: function ({
                                                    item: questItem,
                                                  }) {
                                                    return [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          staticClass: "mr-2",
                                                          attrs: {
                                                            small: "",
                                                            color: "grey",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.edit_quest_in_day(
                                                                day.uid,
                                                                questItem.uid
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("mdi-pencil")]
                                                      ),
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          staticClass: "mr-2",
                                                          attrs: {
                                                            small: "",
                                                            color: "blue",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.moveup_quest_in_day(
                                                                day.uid,
                                                                questItem.uid
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "mdi-arrow-up-thick"
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          staticClass: "mr-2",
                                                          attrs: {
                                                            small: "",
                                                            color: "blue",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.movedown_quest_in_day(
                                                                day.uid,
                                                                questItem.uid
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "mdi-arrow-down-thick"
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            small: "",
                                                            color: "red",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.remove_quest_in_day(
                                                                day.uid,
                                                                questItem.uid
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("mdi-delete")]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c("v-card-actions", {
                        staticClass: "ma-0 pa-1",
                        attrs: { width: "100%", elevation: "0" },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-card",
                    {
                      staticClass: "ma-0 pa-2 mt-2",
                      attrs: { width: "100%", elevation: "0", outlined: "" },
                    },
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "blue--text pa-0 ma-0 ml-1 mb-2" },
                        [_vm._v("Reward Tracks")]
                      ),
                      _vm.model
                        ? _c(
                            "v-expansion-panels",
                            [
                              _c("r-reward-track-panel", {
                                attrs: {
                                  model: _vm.model.rewards,
                                  title: "Reward Track",
                                },
                                on: {
                                  "update:model": function ($event) {
                                    return _vm.$set(
                                      _vm.model,
                                      "rewards",
                                      $event
                                    )
                                  },
                                },
                              }),
                              _c("r-reward-track-panel", {
                                attrs: {
                                  model: _vm.model.rewards_premium,
                                  payable: true,
                                  reminder: true,
                                  title: "Premium Track",
                                },
                                on: {
                                  "update:model": function ($event) {
                                    return _vm.$set(
                                      _vm.model,
                                      "rewards_premium",
                                      $event
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "v-card",
                    {
                      staticClass: "ma-0 pa-2 mt-2",
                      attrs: { width: "100%", elevation: "0", outlined: "" },
                    },
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "red--text pa-0 ma-0 ml-1 mb-2" },
                        [_vm._v("Guards")]
                      ),
                      _c(
                        "v-expansion-panels",
                        [
                          _c("r-guard-panel", {
                            attrs: {
                              model: _vm.model.guard,
                              title: "Guard Config",
                            },
                            on: {
                              "update:model": function ($event) {
                                return _vm.$set(_vm.model, "guard", $event)
                              },
                            },
                          }),
                          _c("r-guard-money-panel", {
                            attrs: {
                              model: _vm.model.guardMoney,
                              title: "Guard Money",
                            },
                            on: {
                              "update:model": function ($event) {
                                return _vm.$set(_vm.model, "guardMoney", $event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-card",
                    {
                      staticClass: "ma-0 pa-2 mt-2",
                      attrs: { width: "100%", elevation: "0", outlined: "" },
                    },
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "green--text pa-0 ma-0 ml-1 mb-2" },
                        [_vm._v("Tooltip")]
                      ),
                      _c(
                        "v-row",
                        { staticClass: "ml-3 mr-3 pb-3", attrs: { dense: "" } },
                        [
                          _c("v-text-field", {
                            staticClass: "pr-4",
                            attrs: {
                              label: "Icon Badge Expires",
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.model.iconBadgeExpires,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.model,
                                  "iconBadgeExpires",
                                  _vm._n($$v)
                                )
                              },
                              expression: "model.iconBadgeExpires",
                            },
                          }),
                          _c("v-text-field", {
                            attrs: {
                              label: "Icon Tooltip Reset",
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.model.iconTooltipReset,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.model,
                                  "iconTooltipReset",
                                  _vm._n($$v)
                                )
                              },
                              expression: "model.iconTooltipReset",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.cancel },
                },
                [_vm._v(" Cancel ")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.save },
                },
                [_vm._v(" Save ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("r-smart-offer-bundle-novice-battle-pass-quest-edit-dialog", {
        ref: "dialog-quests",
      }),
      _c("r-smart-offer-bundle-novice-battle-pass-day-edit-dialog", {
        ref: "dialog-days",
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }